import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { useEffect, useMemo, useState } from 'react';
import BarChart from './BarChart';
import graficoConsumoClient from '../../service/consumoClient';
import Highcharts from 'highcharts';
import Chart from "highcharts-react-official";
 
 
export default function ConsumoCliente() {
  const { t } = useTranslation();
  const [grafico, setGrafico] = useState<any>(null);
  const [graficoExcluido, setGraficoExcluido] = useState<any>(null);
  const [clientesExcluidos, setClientesExcluidos] = useState<any>(null);
  const [clientesIncluidos, setClientesIncluidos] = useState<any>(null);

 
  const generateSerie = (data:any) => {
    const series : any[] = [];
    const categories : any[] = [];
    Object.getOwnPropertyNames(data).forEach((item:any) => {
      series.push(Number(data[item]))
      categories.push(item)
    })
    return {series: {name:'Clientes', data:series}, categoria: {categories : categories}};
  }

  const optionsClienteIncluido = useMemo(() => {
    if (clientesIncluidos) {
      return {
        chart: {
          type: "line"
        },
        title: {
          text: 'Cliente incluídos últimos 30 dias'
        },
        xAxis: {
          categories: clientesIncluidos.categoria.categories
        },
        yAxis: {
          title: { text: 'Quantidade' },
          allowDecimals: false,
          labels: {
            formatter: function (e: any): string {
              return '' + e.value;
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [clientesIncluidos.series]
      };
    } else {
      return null;
    }
  }, [clientesIncluidos]);

  const optionsClienteExcluido = useMemo(() => {
    if (clientesExcluidos) {
      return {
        chart: {
          type: "line"
        },
        title: {
          text: 'Cliente excluídos últimos 30 dias'
        },
        xAxis: {
          categories: clientesExcluidos.categoria.categories
        },
        yAxis: {
          title: { text: 'Quantidade' },
          allowDecimals: false,
          labels: {
            formatter: function (e: any): string {
              return '' + e.value;
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [clientesExcluidos.series]
      };
    } else {
      return null;
    }
  }, [clientesExcluidos]);
 
 
  useEffect(
    () => {
      graficoConsumoClient().then((response) => {
        const dataIncluidos = response.consumoClientesIncluidos
        const dataExcluidos = response.consumoClientesExcluidos
        setClientesExcluidos(generateSerie(response.clientesExcluidos))
        setClientesIncluidos(generateSerie(response.clientesIncluidos))
        const series : any[] = [];
        const seriesDropdown : any[] = [];
        Object.getOwnPropertyNames(dataIncluidos).forEach(item => {
          let total = Number(0);
          const dadosPai : any[] = [];
          Object.getOwnPropertyNames(dataIncluidos[item]).forEach(itemValor => {
            const dados : any[] = [];
            dados.push(itemValor)
            dados.push(Number(dataIncluidos[item][itemValor]))
            total = total + Number(dataIncluidos[item][itemValor]);
            dadosPai.push(dados)
          })
          dadosPai.sort( (b:any,a:any) => {
            if(!a[1]){
              return 1;
            }
      
            if(!b[1]){
              return -1;
            }
      
            if (a[1] > b[1]) {
              return 1;
            }
            if (a[1] < b[1]) {
              return -1;
            }
            return 0;
          } );
          seriesDropdown.push({name: item, id: item, data: dadosPai })
          series.push({name: item , y: total, drilldown: item })
        })
        series.sort( (b:any,a:any) => {
          if(!a.y){
            return 1;
          }
    
          if(!b.y){
            return -1;
          }
    
          if (a.y > b.y) {
            return 1;
          }
          if (a.y < b.y) {
            return -1;
          }
          return 0;
        } );
        setGrafico({series:series, seriesDropdown: seriesDropdown})
        const seriesExcluido : any[] = [];
        const seriesDropdownExcluido : any[] = [];
        Object.getOwnPropertyNames(dataExcluidos).forEach(item => {
          let total = Number(0);
          const dadosPai : any[] = [];
          Object.getOwnPropertyNames(dataExcluidos[item]).forEach(itemValor => {
            const dados : any[] = [];
            dados.push(itemValor)
            dados.push(Number(dataExcluidos[item][itemValor]))
            total = total + Number(dataExcluidos[item][itemValor]);
            dadosPai.push(dados)
          })
          dadosPai.sort( (b:any,a:any) => {
            if(!a[1]){
              return 1;
            }
      
            if(!b[1]){
              return -1;
            }
      
            if (a[1] > b[1]) {
              return 1;
            }
            if (a[1] < b[1]) {
              return -1;
            }
            return 0;
          } );
          seriesDropdownExcluido.push({name: item, id: item, data: dadosPai })
          seriesExcluido.push({name: item , y: total, drilldown: item })
        })
        seriesExcluido.sort( (b:any,a:any) => {
          if(!a.y){
            return 1;
          }
    
          if(!b.y){
            return -1;
          }
    
          if (a.y > b.y) {
            return 1;
          }
          if (a.y < b.y) {
            return -1;
          }
          return 0;
        } );
        setGraficoExcluido({series:seriesExcluido, seriesDropdown: seriesDropdownExcluido})
        
      })
    },[])
 
  return (
    <div >
      
      {grafico && (
        <Panel className="panel-renda" header={t('dashboard')} style={{width:'99%'}}>
          <div className='grid'>
            
            <div style={{width: '50%', paddingRight:'1rem'}}>
              <div style={{height: '28rem'}}  className='card col-12 lg:col-6'>
                <h5 style={{marginTop: '0'}}>Consumo clientes incluídos últimos 30 dias</h5>
                <BarChart key={'chartHoje'} series={grafico.series} seriesDropdown={grafico.seriesDropdown} title={'Consumo clientes incluídos últimos 30 dias'}></BarChart>
              </div>
            </div>
            <div style={{width: '50%', paddingRight:'1rem'}}>
              <div style={{height: '28rem'}}  className='card col-12 lg:col-6'>
                <h5 style={{marginTop: '0'}}>Consumo clientes excluídos últimos 30 dias</h5>
                <BarChart key={'chartHoje'} series={graficoExcluido.series} seriesDropdown={graficoExcluido.seriesDropdown} title={'Consumo clientes excluídos últimos 30 dias'}></BarChart>
              </div>
            </div>
          </div>  
          <div className='grid'>
            <div style={{width: '50%', paddingRight:'1rem'}}>
              <div style={{height: '28rem'}}  className='card col-12 lg:col-6'>
                <h5 style={{marginTop: '0'}}>Clientes incluídos últimos 30 dias</h5>
                <Chart highcharts={Highcharts} options={optionsClienteIncluido} />
              </div>
            </div>
            <div style={{width: '50%', paddingRight:'1rem'}}>
              <div style={{height: '28rem'}}  className='card col-12 lg:col-6'>
                <h5 style={{marginTop: '0'}}>Clientes excluídos últimos 30 dias</h5>
                <Chart highcharts={Highcharts} options={optionsClienteExcluido} />
              </div>
            </div>
          </div>  
          
         
          
        </Panel>
      )}
      
    </div>
  )
}